import React from "react";

function IcEdit({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "17"}
      height={height || "18"}
      fill="none"
      viewBox="0 0 17 18"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.376 17.02H2.81a2.268 2.268 0 01-2.264-2.265V4.19A2.268 2.268 0 012.81 1.926h5.534a.755.755 0 010 1.51H2.81a.755.755 0 00-.754.754v10.565c0 .416.338.755.754.755h10.565a.757.757 0 00.756-.755V9.198a.754.754 0 111.508 0v5.557a2.266 2.266 0 01-2.264 2.264zm-7.55-5.323h1.068L14.9 3.689c.14-.141.22-.33.22-.534a.747.747 0 00-.754-.753.746.746 0 00-.533.22l-8.007 8.007v1.068zm1.38 1.51H5.07a.754.754 0 01-.754-.755v-2.135c0-.2.08-.393.222-.534l8.227-8.23a2.254 2.254 0 011.601-.66c.607 0 1.176.235 1.602.661.426.427.663.995.663 1.601a2.25 2.25 0 01-.663 1.602l-8.23 8.229a.75.75 0 01-.531.22z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default IcEdit;



// WEBPACK FOOTER //
// ./src/app/elements/Icon/ic-edit.js